module.exports = __webpack_public_path__ + "img/3.f890df6f.jpg";